import {Injectable, inject} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorToastService {
  private snackBar = inject(MatSnackBar);
  private translateService = inject(TranslateService);

  show(status?: number) {
    this.snackBar.open(this.getMessage(status), this.translateService.instant('default.ok'), {
      duration: 6000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['global-error-toast'],
    });
  }

  private getMessage(status?: number): string {
    switch (status) {
      case 401:
        return this.translateService.instant('error.toast.401');
      case 403:
        return this.translateService.instant('error.toast.403');
      case 404:
        return this.translateService.instant('error.toast.404');
      case 500:
        return this.translateService.instant('error.toast.500');
      default:
        return this.translateService.instant('error.toast.default');
    }
  }
}
